import { useCallback } from 'react';
import { useActions } from 'store';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import logo from 'assets/images/main_logo_drawer.png';
import IconButton from '@mui/material/IconButton';
import { storeDrawerOpen } from 'store/appSettings/actions';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import { drawerWidth } from 'theme/constants';
import { drawerItems } from './constants';
import { MainDrawerItem } from './MainDrawerItem';

interface Props {
    open: boolean;
}

export const MainDrawer = ({ open }: Props) => {
    const actions = useActions({ storeDrawerOpen });

    const handleDrawerClose = useCallback(() => actions.storeDrawerOpen(false), [actions]);

    return (
        <Drawer
            variant="temporary"
            open={open}
            onClose={handleDrawerClose}
            ModalProps={{
                keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
        >
            <Box display="flex" alignItems="center" gap={2} py={0.875} px={1}>
                <img src={logo} alt="contaldi lit it" height={50} />
                <IconButton onClick={handleDrawerClose}>
                    <ChevronLeftIcon />
                </IconButton>
            </Box>
            <Divider />
            <List>
                {drawerItems.map((item, index) => (
                    <MainDrawerItem key={index} {...item} onClose={handleDrawerClose} />
                ))}
            </List>
        </Drawer>
    );
};
